/* fl-motion.js — lightweight homepage motion: IntersectionObserver reveals + count-up.
   No GSAP, no Lenis, no WebGL, no continuous render loop. Gated behind html.fl-motion
   (set pre-paint by the inline script in the hero); content is fully visible without it. */
(function () {
  var d = document.documentElement;
  if (window.__flRev) return; // inline end-of-body observer already ran
  if (!d.classList.contains('fl-motion')) return; // reduced-motion / not flagged → content visible
  d.classList.add('fl-motion-init');

  function run() {
    var reveals = [].slice.call(document.querySelectorAll('[data-anim="reveal"]'));
    var counts = [].slice.call(document.querySelectorAll('[data-anim="count"]'));

    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (e) { e.classList.add('fl-in'); });
      return;
    }

    var rio = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('fl-in'); rio.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    reveals.forEach(function (e) { rio.observe(e); });

    var cio = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { countUp(en.target); cio.unobserve(en.target); } });
    }, { threshold: 0.4 });
    counts.forEach(function (e) { cio.observe(e); });

    function countUp(el) {
      var out = el.querySelector('[data-count-value]') || el;
      var to = parseInt(el.getAttribute('data-to'), 10);
      if (isNaN(to)) to = parseInt((out.textContent || '').replace(/\D/g, ''), 10) || 0;
      var dur = 1400, t0 = null;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        out.textContent = Math.round((1 - Math.pow(1 - p, 3)) * to);
        if (p < 1) requestAnimationFrame(step); // runs only during the ~1.4s count, then stops
      }
      requestAnimationFrame(step);
    }
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
